export enum Region {
  Seoul = '서울',
  Busan = '부산',
  Incheon = '인천',
  Daegu = '대구',
  GwangJu = '광주',
  DaeJeon = '대전',
  Ulsan = '울산',
  Gyeonggi = '경기',
  Gangwon = '강원',
  Chungbuk = '충북',
  Chungnam = '충남',
  Jeonbuk = '전북',
  Jeonnam = '전남',
  Geyongnam = '경남',
  Geyongbuk = '경북',
  Jeju = '제주'
}

export enum Lands {
  '명지녹산국가산업단지',
  '남동국가산업단지',
  '한국수출산업국가산업단지(부평주안국가산업단지)',
  '대구국가과학산업단지',
  '광주첨단과학산업단지',
  '대덕연구개발특구',
  '온산국가산업단지',
  '울산미포국가산업단지',
  '반월특수지역(반월지구)',
  '반월특수지역(시화지구)',
  '파주출판문화정보산업단지',
  '파주탄현중소기업전용국가산업단지',
  '북평국가산업단지',
  '보은국가산업단지',
  '오송생명과학산업단지',
  '고정국가산업단지',
  '대죽자원비축산업단지',
  '석문국가산업단지아산국가산업단지-고대, 부곡지구',
  '장항국가산업단지',
  '군산국가산업단지',
  '군산2국가산업단',
  '지익산국가산업단지',
  '광양국가산업단지',
  '대불국가산업단지',
  '삼일자원비축단지',
  '여수국가산업단지',
  '구미국가산업단지',
  '월성전원단지',
  '포항국가산업단지',
  '안정국가산업단지',
  '옥포국가산업단지',
  '죽도국가산업단지',
  '지세포자원비축단지',
  '진해국가산업단지',
  '창원국가산업단지',
  '제주첨단과학기술단지'
}

/** 기업 규모 */
export enum IndustrialCompanyScaleForFrontEnd {
  MajorCompany = 'MAJOR_COMPANY',
  MidSizedCompany = 'MID_SIZED_COMPANY',
  /** NULL */
  SmallCompany = 'SMALL_COMPANY',
  Null = 'NULL'
}

/** 단지명 */
export enum IndustrialComplexNameForFrontEnd {
  /** 남동국가산업단지 */
  IndustrialComplex_1 = 'INDUSTRIAL_COMPLEX_1',
  /** 광양국가산업단지 */
  IndustrialComplex_2 = 'INDUSTRIAL_COMPLEX_2',
  /** 광주월전중소협력단지형외국인투자지역 */
  IndustrialComplex_3 = 'INDUSTRIAL_COMPLEX_3',
  /** 광주첨단과학국가산업단지 */
  IndustrialComplex_4 = 'INDUSTRIAL_COMPLEX_4',
  /** 구미국가산업단지 */
  IndustrialComplex_5 = 'INDUSTRIAL_COMPLEX_5',
  /** 구미외국인투자지역 */
  IndustrialComplex_6 = 'INDUSTRIAL_COMPLEX_6',
  /** 국가식품클러스터국가산업단지 */
  IndustrialComplex_7 = 'INDUSTRIAL_COMPLEX_7',
  /** 국가식품클러스터식품산업단지중소협력단지형외국인투자지역 */
  IndustrialComplex_8 = 'INDUSTRIAL_COMPLEX_8',
  /** 군산2국가산업단지 */
  IndustrialComplex_9 = 'INDUSTRIAL_COMPLEX_9',
  /** 군산국가산업단지 */
  IndustrialComplex_10 = 'INDUSTRIAL_COMPLEX_10',
  /** 김해GoldenRoot일반산업단지 */
  IndustrialComplex_11 = 'INDUSTRIAL_COMPLEX_11',
  /** 달성2차외국인투자지역 */
  IndustrialComplex_12 = 'INDUSTRIAL_COMPLEX_12',
  /** 달성2차일반산업단지 */
  IndustrialComplex_13 = 'INDUSTRIAL_COMPLEX_13',
  /** 대구국가산업단지 */
  IndustrialComplex_14 = 'INDUSTRIAL_COMPLEX_14',
  /** 대불국가산업단지 */
  IndustrialComplex_15 = 'INDUSTRIAL_COMPLEX_15',
  /** 대불외국인투자지역 */
  IndustrialComplex_16 = 'INDUSTRIAL_COMPLEX_16',
  /** 명지녹산국가산업단지 */
  IndustrialComplex_17 = 'INDUSTRIAL_COMPLEX_17',
  /** 문막중소협력단지형외국인투자지역 */
  IndustrialComplex_18 = 'INDUSTRIAL_COMPLEX_18',
  /** 반월국가산업단지 */
  IndustrialComplex_19 = 'INDUSTRIAL_COMPLEX_19',
  /** 부산신평장림일반산업단지(협업단지) */
  IndustrialComplex_20 = 'INDUSTRIAL_COMPLEX_20',
  /** 북평국가산업단지 */
  IndustrialComplex_21 = 'INDUSTRIAL_COMPLEX_21',
  /** 빛그린국가산업단지 */
  IndustrialComplex_22 = 'INDUSTRIAL_COMPLEX_22',
  /** 서울디지털국가산업단지 */
  IndustrialComplex_23 = 'INDUSTRIAL_COMPLEX_23',
  /** 시화국가산업단지 */
  IndustrialComplex_24 = 'INDUSTRIAL_COMPLEX_24',
  /** 시화멀티테크노밸리 */
  IndustrialComplex_25 = 'INDUSTRIAL_COMPLEX_25',
  /** 아산국가산업단지(포승지구) */
  IndustrialComplex_26 = 'INDUSTRIAL_COMPLEX_26',
  /** 여수국가산업단지 */
  IndustrialComplex_27 = 'INDUSTRIAL_COMPLEX_27',
  /** 오송생명과학단지 */
  IndustrialComplex_28 = 'INDUSTRIAL_COMPLEX_28',
  /** 온산국가산업단지 */
  IndustrialComplex_29 = 'INDUSTRIAL_COMPLEX_29',
  /** 울산미포국가산업단지 */
  IndustrialComplex_30 = 'INDUSTRIAL_COMPLEX_30',
  /** 익산국가산업단지 */
  IndustrialComplex_31 = 'INDUSTRIAL_COMPLEX_31',
  /** 장성동화농공단지 */
  IndustrialComplex_32 = 'INDUSTRIAL_COMPLEX_32',
  /** 장성삼계농공단지 */
  IndustrialComplex_33 = 'INDUSTRIAL_COMPLEX_33',
  /** 창원국가산업단지 */
  IndustrialComplex_34 = 'INDUSTRIAL_COMPLEX_34',
  /** 청주오송제2생명과학일반산업단지(충북경제자유구역 오송바이오폴리스지구) */
  IndustrialComplex_35 = 'INDUSTRIAL_COMPLEX_35',
  /** 한국수출산업(부평)국가산업단지 */
  IndustrialComplex_36 = 'INDUSTRIAL_COMPLEX_36',
  /** 한국수출산업(주안)국가산업단지 */
  IndustrialComplex_37 = 'INDUSTRIAL_COMPLEX_37',
  /** 석문국가산업단지 */
  IndustrialComplex_38 = 'INDUSTRIAL_COMPLEX_38',
  /** 아산국가산업단지(고대부곡지구) */
  IndustrialComplex_39 = 'INDUSTRIAL_COMPLEX_39',
  /** 충주외국인투자지역 */
  IndustrialComplex_40 = 'INDUSTRIAL_COMPLEX_40',
  /** 파주탄현중소기업전용국가산업단지 */
  IndustrialComplex_41 = 'INDUSTRIAL_COMPLEX_41',
  /** 원주문막반계일반산업단지 */
  IndustrialComplex_42 = 'INDUSTRIAL_COMPLEX_42',
  /** 북평일반산업단지 */
  IndustrialComplex_43 = 'INDUSTRIAL_COMPLEX_43',
  /** 양주홍죽일반산업단지 */
  IndustrialComplex_44 = 'INDUSTRIAL_COMPLEX_44',
  /** 송산2외국인투자지역 */
  IndustrialComplex_45 = 'INDUSTRIAL_COMPLEX_45',
  /** 사천제2일반산업단지 */
  IndustrialComplex_46 = 'INDUSTRIAL_COMPLEX_46',
  /** 송산2-1외국인투자지역 */
  IndustrialComplex_47 = 'INDUSTRIAL_COMPLEX_47',
  /** 사천제1일반산업단지 */
  IndustrialComplex_48 = 'INDUSTRIAL_COMPLEX_48',
  /** 사천외국인투자지역 */
  IndustrialComplex_49 = 'INDUSTRIAL_COMPLEX_49',
  /** 아산제2테크노밸리일반산업단지 */
  IndustrialComplex_50 = 'INDUSTRIAL_COMPLEX_50',
  /** 이천장호원일반산업단지 */
  IndustrialComplex_51 = 'INDUSTRIAL_COMPLEX_51',
  /** 천안외국인투자지역 */
  IndustrialComplex_52 = 'INDUSTRIAL_COMPLEX_52',
  /** 사천임대전용산업단지 */
  IndustrialComplex_53 = 'INDUSTRIAL_COMPLEX_53',
  /** 천안5산단외국인투자지역 */
  IndustrialComplex_54 = 'INDUSTRIAL_COMPLEX_54',
  /** 진해국가산업단지 */
  IndustrialComplex_55 = 'INDUSTRIAL_COMPLEX_55',
  /** 진천산수외국인투자지역 */
  IndustrialComplex_56 = 'INDUSTRIAL_COMPLEX_56',
  /** 이천대월일반산업단지 */
  IndustrialComplex_57 = 'INDUSTRIAL_COMPLEX_57',
  /** 인주외국인투자지역 */
  IndustrialComplex_58 = 'INDUSTRIAL_COMPLEX_58',
  /** 포항국가산업단지 */
  IndustrialComplex_59 = 'INDUSTRIAL_COMPLEX_59',
  /** 장항국가생태산업단지 */
  IndustrialComplex_60 = 'INDUSTRIAL_COMPLEX_60',
  /** 오창외국인투자지역 */
  IndustrialComplex_61 = 'INDUSTRIAL_COMPLEX_61',
  /** 포항블루밸리국가산업단지 */
  IndustrialComplex_62 = 'INDUSTRIAL_COMPLEX_62',
  /** 안정국가산업단지 */
  IndustrialComplex_63 = 'INDUSTRIAL_COMPLEX_63',
  /** 송산2-2외국인투자지역 */
  IndustrialComplex_64 = 'INDUSTRIAL_COMPLEX_64'
}

/** 업종_대분류 */
export enum IndustrialSectorsCategoryForFrontEnd {
  NonManufacturing = 'NON_MANUFACTURING',
  Produce = 'PRODUCE'
}

/** 업종 */
export enum IndustrialSectorsNameForFrontEnd {
  /** 01. 음식료 */
  SectorName_1 = 'SECTOR_NAME_1',
  /** 02. 섬유의복 */
  SectorName_2 = 'SECTOR_NAME_2',
  /** 03. 목재종이 */
  SectorName_3 = 'SECTOR_NAME_3',
  /** 04. 석유화학 */
  SectorName_4 = 'SECTOR_NAME_4',
  /** 05. 비금속 */
  SectorName_5 = 'SECTOR_NAME_5',
  /** 06. 철강 */
  SectorName_6 = 'SECTOR_NAME_6',
  /** 07. 기계 */
  SectorName_7 = 'SECTOR_NAME_7',
  /** 08. 전기전자 */
  SectorName_8 = 'SECTOR_NAME_8',
  /** 09. 운송장비 */
  SectorName_9 = 'SECTOR_NAME_9',
  /** 10. (제조)기타 */
  SectorName_10 = 'SECTOR_NAME_10',
  /** 11. 정보통신업 */
  SectorName_11 = 'SECTOR_NAME_11',
  /** 13. 출판업 */
  SectorName_13 = 'SECTOR_NAME_13',
  /** 14. (비제조)기타 */
  SectorName_14 = 'SECTOR_NAME_14'
}
